export const GasPump = ({ className }) => {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1688_100464)">
        <path
          d="M3.37109 13.626V3.62598C3.37109 3.36076 3.47645 3.10641 3.66399 2.91887C3.85153 2.73133 4.10588 2.62598 4.3711 2.62598H9.37114C9.63636 2.62598 9.89071 2.73133 10.0782 2.91887C10.2658 3.10641 10.3711 3.36076 10.3711 3.62598V13.626"
          stroke="#FF922E"
          strokeWidth="0.999996"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1.87109 13.625H11.8712"
          stroke="#FF922E"
          strokeWidth="0.999996"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.3711 7.12598H11.8711C12.1363 7.12598 12.3907 7.23133 12.5782 7.41887C12.7658 7.60641 12.8711 7.86076 12.8711 8.12598V10.626C12.8711 10.8912 12.9765 11.1455 13.164 11.3331C13.3515 11.5206 13.6059 11.626 13.8711 11.626C14.1363 11.626 14.3907 11.5206 14.5782 11.3331C14.7658 11.1455 14.8711 10.8912 14.8711 10.626V5.54035C14.8711 5.40895 14.8453 5.27883 14.795 5.15743C14.7447 5.03603 14.6709 4.92574 14.578 4.83285L13.3711 3.62598"
          stroke="#FF922E"
          strokeWidth="0.999996"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.37112 7.12598H5.37109"
          stroke="#FF922E"
          strokeWidth="0.999996"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1688_100464">
          <rect
            width="16.0001"
            height="16"
            fill="white"
            transform="translate(0.671875 0.125977)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
